import * as React from 'react'
import cx from 'classnames'
import { IconWrapper, IconProps, sizes } from '../../IconWrapper'
export const InstagramIcon = React.forwardRef(function InstagramIcon(
  props: IconProps,
  ref?: React.ForwardedRef<HTMLElement>
) {
  return (
    <IconWrapper ref={ref} {...props}>
      <>
        {
          <svg
            width={24}
            height={24}
            viewBox='0 0 24 24'
            fill='none'
            className={cx(
              'inline-block align-middle',
              sizes[props.size || 'sm'].className
            )}
          >
            <path
              fillRule='evenodd'
              clipRule='evenodd'
              d='M12.962 2H16.142c1.088.084 1.758.251 2.427.502.67.251 1.255.586 1.757 1.172.586.585.92 1.088 1.172 1.757.251.67.418 1.339.502 2.427v8.284c-.084 1.088-.251 1.841-.502 2.427-.251.67-.586 1.255-1.172 1.757-.585.502-1.088.92-1.757 1.172-.67.25-1.339.418-2.427.502H7.858c-1.088-.084-1.758-.251-2.427-.502-.67-.251-1.255-.586-1.757-1.172-.586-.585-.92-1.088-1.172-1.757-.25-.67-.418-1.339-.502-2.427v-.837V11.039 8.444v-.586c.084-1.088.251-1.758.502-2.427.251-.67.586-1.255 1.172-1.757.585-.586 1.088-.92 1.757-1.172.67-.25 1.339-.418 2.427-.502H12.962zm0 1.757h-1.924c-1.841 0-2.176 0-3.097.084-1.004.084-1.506.167-1.84.335-.503.167-.837.418-1.172.753-.335.335-.586.67-.753 1.171-.168.335-.335.921-.335 1.841 0 .921-.084 1.256-.084 3.097v1.924c0 1.841 0 2.176.084 3.097.084 1.004.167 1.506.335 1.84.167.503.418.837.753 1.172.335.335.67.586 1.171.753.335.168.92.335 1.841.335.92 0 1.256.084 3.097.084h1.924c1.841 0 2.176 0 3.097-.084 1.004-.084 1.506-.167 1.84-.335.503-.167.837-.418 1.172-.753.335-.335.586-.67.753-1.171.168-.335.335-.92.335-1.841.084-.92.084-1.256.084-3.097v-1.924c0-1.841 0-2.176-.084-3.097-.084-1.004-.167-1.506-.335-1.84-.167-.503-.418-.837-.753-1.172-.335-.335-.67-.586-1.171-.753-.335-.168-.92-.335-1.841-.335-.92-.084-1.256-.084-3.097-.084zm-.92 3.097c2.845 0 5.188 2.343 5.188 5.188 0 2.845-2.343 5.188-5.188 5.188-2.845 0-5.188-2.343-5.188-5.188 0-2.845 2.343-5.188 5.188-5.188zm0 1.84a3.357 3.357 0 00-3.347 3.348 3.357 3.357 0 003.347 3.347 3.357 3.357 0 003.347-3.347c0-1.925-1.506-3.347-3.347-3.347zm5.356-3.263c.669 0 1.171.502 1.171 1.172 0 .669-.502 1.171-1.171 1.171-.67 0-1.172-.502-1.172-1.171-.084-.586.502-1.172 1.172-1.172z'
              fill='currentColor'
            />
          </svg>
        }
      </>
    </IconWrapper>
  )
})
